import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import PhoneIcon from '../../ui/svg/Components/PhoneIcon';
import googleMapUtils from '../../../utils/googleMapUtils';
import useStyles from './PudoSavedAddressText.styles';

const PudoSavedAddressText = (props) => {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  if (!props.address) return null;
  return (
    <label
      htmlFor={props.id}
      className={classes.pudoSavedAddressText}
      data-test="PudoSavedAddress__radio-label"
      data-cs-mask
    >
      <div className={classes.fullName} data-test="PudoSavedAddressText__name">
        {props.address.name}
      </div>
      <div className={classes.address} data-test="PudoSavedAddressText__address">
        {`${props.address.organisationName}, ${googleMapUtils.addressFormatter(props.address)}`}
      </div>
      {props.contactNumber && (
        <span className={classes.contactNumber} data-test="PudoSavedAddressText__contactNumber">
          <PhoneIcon className={classes.phoneIcon} />
          {props.contactNumber}
        </span>
      )}
    </label>
  );
};

PudoSavedAddressText.propTypes = {
  id: PropTypes.number,
  address: PropTypes.shape({
    name: PropTypes.string,
    organisationName: PropTypes.string,
    buildingNameNumber: PropTypes.string,
    line1: PropTypes.string,
    line2: PropTypes.string,
    line3: PropTypes.string,
    line4: PropTypes.string,
    postcode: PropTypes.string,
    countryCode: PropTypes.string,
    courierId: PropTypes.string,
    locationId: PropTypes.string,
  }),
  contactNumber: PropTypes.string.isRequired,
  paddingLeft: PropTypes.bool.isRequired,
};

export default PudoSavedAddressText;
